import type { MediaKind, MediaRef } from "@velizhanin-dev/bot-scenario"
import { apiClient } from "@/shared/api/client"
import { scenarioPath } from "./keys"

// --- медиа ---

export const presignScenarioMedia = async (
	id: string,
	body: { kind: MediaKind; fileName: string; mime: string; size: number },
) =>
	(
		await apiClient.post<{ uploadUrl: string; expiresIn: number; media: MediaRef }>(
			scenarioPath(id, "/media/presign"),
			body,
		)
	).data

export const getScenarioMediaUrl = async (id: string, s3Key: string) =>
	(
		await apiClient.get<{ url: string; expiresIn: number }>(scenarioPath(id, "/media/url"), {
			params: { s3Key },
		})
	).data
